// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Components
import ErrorPage from './ErrorPage';

// Selectors
import { getSelfCheckInData } from 'store/reducers/selfCheckIn/selectors';
import { getVehicle, getStartTime } from 'store/reducers/appointment/selectors';

import { getErrorType } from 'store/reducers/appointment/selfCheckIn/selectors';

const mapStateToProps = state => ({
  selfCheckInData: getSelfCheckInData(state),
  vehicle: getVehicle(state),
  startTime: getStartTime(state),
  errorType: getErrorType(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(ErrorPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ErrorPage/ErrorPageContainer.js